import { render, staticRenderFns } from "./report-CollectionCodeChange.vue?vue&type=template&id=4b80d0ee&"
import script from "./report-CollectionCodeChange.vue?vue&type=script&lang=ts&"
export * from "./report-CollectionCodeChange.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports